import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import {
  toppingPayloadModel,
  toppingPutPayloadModel,
  toppingResponseModel,
  toppingsResponseModel
} from './ToppingsAPI.model'

class ToppingsAPI {
  static getToppings = (): Promise<toppingsResponseModel> =>
    HTTPInstanceWithPrefix.get('/toppings').then(response => response.data)

  static getTopping = (toppingId: string): Promise<toppingResponseModel> =>
    HTTPInstanceWithPrefix.get(`/toppings/${toppingId}`).then(
      response => response.data
    )

  static postTopping = (
    payload: toppingPayloadModel
  ): Promise<toppingPayloadModel> =>
    HTTPInstanceWithPrefix.post('/toppings', payload).then(
      response => response.data
    )

  static putTopping = (
    toppingPayload: toppingPayloadModel,
    toppingId: string
  ): Promise<toppingPutPayloadModel> =>
    HTTPInstanceWithPrefix.put(`/toppings/${toppingId}`, toppingPayload).then(
      response => response.data
    )

  static deleteToppings = (toppingIds: string[]): Promise<void> =>
    HTTPInstanceWithPrefix.delete('/toppings', {
      data: { ids: toppingIds }
    }).then(response => response.data)
}

export default ToppingsAPI
